import React from 'react';
import PropTypes from 'prop-types';

import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import classes from './sensitivityNotice.module.css';

const SensitivityNotice = ({ onClick, numRows = 3, customClass = '' }) => {

    return (
        <div
            className={`${classes.sensitivityNotice} ${numRows === 1 ? classes.oneRow : ''} ${
                numRows === 2 ? classes.twoRows : ''
            } ${customClass ? classes[customClass] : ''}`}
            data-testid="sensitivity-notice">
            <VisibilityOffIcon />
            <div className={classes.content}>
                <div>The hidden information is of a sensitive nature.</div>
                <div>
                    You must ensure that nobody else has the ability to see your screen before
                    revealing it.
                </div>
            </div>
            <div className={classes.reveal} onClick={onClick}>
                Click here to reveal
            </div>
        </div>
    );
};

SensitivityNotice.propTypes = {
    onClick: PropTypes.func.isRequired,
    numRows: PropTypes.number,
    customClass: PropTypes.string
};

export default SensitivityNotice;
